import { createContext } from 'react'

export const TableContext = createContext({
  isScrolled: false
})
